import { render, staticRenderFns } from "./healthAdvisory.vue?vue&type=template&id=45dedd82&scoped=true&"
import script from "./healthAdvisory.vue?vue&type=script&lang=ts&"
export * from "./healthAdvisory.vue?vue&type=script&lang=ts&"
import style0 from "./healthAdvisory.vue?vue&type=style&index=0&id=45dedd82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dedd82",
  null
  
)

export default component.exports